import Icon from 'veui/components/Icon'

Icon.register({
  'disc-x': {
    paths: [
      {
        d: 'M384 32C189.6 32 32 189.6 32 384s157.6 352 352 352 352-157.6 352-352S578.4 32 384 32zm150.63 457.37a32 32 0 01-45.26 45.26L384 429.26 278.63 534.63a32 32 0 01-45.26-45.26L338.74 384 233.37 278.63a32 32 0 0145.26-45.26L384 338.74l105.37-105.37a32 32 0 0145.26 45.26L429.26 384z'
      }
    ],
    width: '768',
    height: '768'
  }
})
